/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demoerziehung13Inputs */

const en__field_enum_demoerziehung13 = /** @type {(inputs: _Field_Enum_Demoerziehung13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04 - Erziehungswissenschaften`)
};

const de__field_enum_demoerziehung13 = /** @type {(inputs: _Field_Enum_Demoerziehung13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04 - Erziehungswissenschaften`)
};

/**
* | output |
* | --- |
* | "04 - Erziehungswissenschaften" |
*
* @param {_Field_Enum_Demoerziehung13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demoerziehung13 = /** @type {((inputs?: _Field_Enum_Demoerziehung13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demoerziehung13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demoerziehung13(inputs)
	return de__field_enum_demoerziehung13(inputs)
});
export { _field_enum_demoerziehung13 as "_field_enum_DEMOERZIEHUNG" }